import React from 'react';
import { ClientSVG } from '../../../components';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function ClientHeader () {
    const { t } = useTranslation();

    return (
        <Box
            display='flex'
            alignItems='center'
            style={{ height: '58px' }}>
            <Box className='svgIcon'>
                <ClientSVG/>
            </Box>
            <Typography variant='pageHeaderTitle' className='headerText'>{t('clients.title')}</Typography>
        </Box>
    );
}
